import { render, staticRenderFns } from "./SendNotifications.vue?vue&type=template&id=39197f84&scoped=true&lang=true&"
import script from "./SendNotifications.vue?vue&type=script&lang=js&"
export * from "./SendNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39197f84",
  null
  
)

export default component.exports